const {UriBuilder} = require("uribuilder");
module.exports = (app) => app.controller('orderConfirmationCreateController', /* @ngInject */ function ($scope, iframeConfig, $sce) {
    $scope.init = init;
    $scope.$on('$destroy', handleDestroy);

    $scope.iframeId = 'orderConfirmationCreateIframe';

    let iframeEl;

    /**
     * @type {string}
     */
    let orderNumber;

    function init(orderId) {
        orderNumber = orderId;
        initIframe();
    }

    function initIframe() {
        iframeConfig.listenToIframeMessages($scope.iframeId);
        const eprocVersion = sessionStorage.getItem(STORAGE_KEY.EPROC_VERSION);
        const path = `client/order/${orderNumber}/create-confirmation`;
        const iframeRoute = UriBuilder.parse(location.protocol + '//' + iframeConfig.iframeBase + path);
        iframeRoute.query.version = eprocVersion;
        iframeEl = angular.element(`#${$scope.iframeId}`);
        iframeEl[0].onload = () => {
            $scope.$apply();
        }

        iframeEl.attr('src', trustSrc(iframeRoute.toString()));
    }

    function handleDestroy() {
        iframeConfig.stopListeningToIframeMessages();
    }

    function trustSrc(src) {
        return $sce.trustAsResourceUrl(src);
    }

});